import { t } from "@/i18n-js/instance";
import { Collapsible } from "@circle-react-uikit/Collapsible";
import { Form } from "@circle-react-uikit/Form";
import { useCustomColors } from "../../../../ThemeConfiguration/hooks/useCustomColors";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";
import type { ButtonType } from "./constants";

interface BackgroundProps {
  buttonType: ButtonType;
  selectedButtonVariant: ButtonVariant;
}

export const Background = ({
  selectedButtonVariant,
  buttonType,
}: BackgroundProps) => {
  const { flattenedCssVariables } = useCustomColors();
  return (
    <Collapsible
      title={t("builder_ui.prop_type.styles.background")}
      defaultOpen
    >
      <div className="px-6 py-5">
        <Form.Item
          name={generateFormItemName(
            buttonType,
            selectedButtonVariant,
            "backgroundColor",
          )}
          label={t("builder_ui.prop_type.styles.background_color")}
          hideDescription
          hideBorder
          className="!flex !w-full !items-center !justify-between !p-0"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(
              buttonType,
              selectedButtonVariant,
              "backgroundColor",
            )}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
          />
        </Form.Item>
      </div>
    </Collapsible>
  );
};
